import { render, staticRenderFns } from "./LangCheck.vue?vue&type=template&id=1bc42692&scoped=true&"
import script from "./LangCheck.vue?vue&type=script&lang=js&"
export * from "./LangCheck.vue?vue&type=script&lang=js&"
import style0 from "./LangCheck.vue?vue&type=style&index=0&id=1bc42692&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc42692",
  null
  
)

export default component.exports